<template>
  <div class="carrousel-element container-testimonial">
    <div class="row justify-content-center">
      <div class="col-12 col-md-4 col-lg-5 vertical-align order-2 order-md-1 order-lg-1">
        <div>
          <img :src="vehicleImage" class="mx-100" alt="SUSTITUIR POR LOS NOMBRES DE LOS VEHICULOS PARA EL SEO" style="
    width: auto;
">
          <h6 class="font-weight-bold text-left text-light">{{vehicleText}}</h6>
        </div>
      </div>
      <div class="col-12 col-md-4 col-lg-5 order-1 order-md-2 order-lg-2">
        <h4 class="text-center text-light mb-24">{{title}}</h4>
        <!-- <img :src="clientImagen" class="rounded-circle mb-16 d-block mx-auto" style="max-width: 100px; border: 3px solid white;" alt="NOMBRE DE CLIENTE"> -->
        <h6 class="text-light text-center">{{client}}</h6>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Testimonial',
  props: {
    title: String,
    vehicleImage: String,
    vehicleText: String,
    client: String,
    clientImagen: String
  }
}
</script>

<style scoped>

</style>
